import { Routes, Route, Outlet } from 'react-router-dom';
import BannerTable from './BannerTable';
import BannerForm from './BannerForm';
import { AuthorizedRoute } from 'app/atoms';
import { PERMISSIONS_SUBJECTS } from '../Auth/constants';
import { ROOT } from 'configs/routeNames';
import { PermissionActions } from '../Auth/types';

export default function Banners() {
  return (
    <>
      <Routes>
        <Route index Component={BannerTable} />
        <Route
          path="edit/:id"
          element={
            <AuthorizedRoute
              requiredPermissions={[{ action: PermissionActions.VIEW_BANNERS, subject: PERMISSIONS_SUBJECTS.BANNERS }]}
              Component={BannerForm}
              redirect={ROOT}
            />
          }
        />
        <Route
          path="create"
          element={
            <AuthorizedRoute
              requiredPermissions={[{ action: PermissionActions.ADD_BANNERS, subject: PERMISSIONS_SUBJECTS.BANNERS }]}
              Component={BannerForm}
              redirect={ROOT}
            />
          }
        />
      </Routes>
      <Outlet />
    </>
  );
}
